import { ParticipantRepository } from '../repositories';

export class DeleteParticipantUseCase {
  constructor(private participantRepository: ParticipantRepository) {}

  async execute(participantId: string): Promise<void> {
    await this.participantRepository.delete(participantId);
  }
}
